<template>
  <tr v-if="prices">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
      <v-row align="center" no-gutters>
        <v-icon x-small class="mx-1 mr-2">mdi-help-circle-outline</v-icon> Min/Max Stay
      </v-row>
    </th>
    <td class="sheet-cell" v-for="(price, index) in prices" :key="index">

      <v-progress-circular v-if="price.maiu" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.min_stay_arrival" class="sheet-input-left" @change="updateMinStay(price)"/>

      <v-progress-circular v-if="price.maau" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.max_stay_arrival" class="sheet-input-right" @change="updateMaxStay(price)"/>

    </td>
  </tr>
</template>


<script>
  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      prices: null
    },

    methods: {

      async updateMinStay(data) {
        try {
          this.$set(data, 'maiu', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'maiu', false);
        }
      },

      async updateMaxStay(data) {
        try {
          this.$set(data, 'maau', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'maau', false);
        }
      }

    }
  }
</script>


<style scoped>
  @import '../sheet.css';
</style>